import { uniqBy } from 'lodash';

const getUniqueMaterials = materials =>
  uniqBy(materials.filter(Boolean), 'materialId');

export default getUniqueMaterials;
